import React, { createContext, useContext } from 'react';

export const LIGHT = {
  bg:         '#f5f6fa',
  card:       '#ffffff',
  card2:      '#f0f2f8',
  border:     '#e4e6ef',
  primary:    '#1a3cc8',
  accent:     '#e8231a',
  green:      '#00b386',
  yellow:     '#f5a623',
  red:        '#e8231a',
  purple:     '#7c3aed',
  orange:     '#f97316',
  pink:       '#db2777',
  cyan:       '#0891b2',
  text:       '#0f1729',
  text2:      '#374151',
  muted:      '#9ca3af',
  input:      '#f0f2f8',
  inputBorder:'#d1d5db',
  shadow:     '0 2px 12px rgba(26,60,200,0.08)',
  shadowMd:   '0 4px 24px rgba(26,60,200,0.12)',
  navBg:      'rgba(255,255,255,0.97)',
};

export const DARK = {
  bg:         '#0a0a12',
  card:       '#12121f',
  card2:      '#1a1a2e',
  border:     '#1e1e3a',
  primary:    '#4f6ef7',
  accent:     '#e8231a',
  green:      '#10b981',
  yellow:     '#f59e0b',
  red:        '#ef4444',
  purple:     '#8b5cf6',
  orange:     '#f97316',
  pink:       '#ec4899',
  cyan:       '#06b6d4',
  text:       '#ffffff',
  text2:      '#cbd5e1',
  muted:      '#555577',
  input:      '#1a1a2e',
  inputBorder:'#2a2a4a',
  shadow:     '0 2px 12px rgba(0,0,0,0.4)',
  shadowMd:   '0 4px 24px rgba(0,0,0,0.5)',
  navBg:      'rgba(10,10,18,0.97)',
};

const ThemeCtx = createContext(LIGHT);

export function ThemeProvider({ isDark, children }) {
  const theme = isDark ? DARK : LIGHT;
  return React.createElement(
    ThemeCtx.Provider,
    { value: theme },
    children
  );
}

export function useTheme() {
  return useContext(ThemeCtx);
}

export function useAppStyles() {
  const C = useTheme();
  return {
    screen: {
      minHeight: '100vh',
      background: C.bg,
      padding: '20px 16px 0px',
      color: C.text,
    },
    card: {
      background: C.card,
      border: `1px solid ${C.border}`,
      borderRadius: 16,
      padding: 20,
      color: C.text,
      boxShadow: C.shadow,
    },
    input: {
      width: '100%',
      background: C.input,
      border: `1px solid ${C.inputBorder}`,
      borderRadius: 12,
      padding: '13px 16px',
      color: C.text,
      fontSize: 15,
      outline: 'none',
      boxSizing: 'border-box',
    },
    label: {
      fontSize: 12,
      color: C.muted,
      display: 'block',
      marginBottom: 6,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: 0.5,
    },
  };
}
